import { BrandName } from "@/components/BrandName";
import { Link } from "react-router-dom";
import { useHomeNavigation } from "@/lib/useHomeNavigation";
import { CONTACT } from "@/lib/contact";

const SERVICE_LINKS = ["Study Abroad Consulting", "Study Visa Consultation", "Education Loan Assistance", "Accommodation Support"];
const DESTINATION_LINKS = ["United Kingdom", "USA", "Canada", "Australia", "Germany", "New Zealand"];
const DESTINATION_SLUGS = ["uk", "usa", "canada", "australia", "germany", "new-zealand"];

export default function Footer() {
  const scrollToSection = useHomeNavigation();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-surface/60">
      <div className="container-x grid grid-cols-1 gap-12 py-16 sm:grid-cols-2 lg:grid-cols-12 lg:py-20">
        <div className="min-w-0 lg:col-span-4">
          <BrandName placement="footer" />
          <p data-testid="footer-description" className="mt-5 max-w-sm text-sm leading-relaxed text-mist">
            A study-abroad consultancy turning student ambitions into
            offer letters, visas and boarding passes.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-mint">Services</p>
          <ul className="mt-5 space-y-3">
            {SERVICE_LINKS.map((s) => (
              <li key={s}>
                {s === "Education Loan Assistance" ? <Link to="/education-loan" data-testid="footer-service-link-education-loan-assistance" className="text-sm text-mist transition-colors hover:text-frost">{s}</Link> : <button
                  onClick={() => scrollToSection("#services")}
                  data-testid={`footer-service-link-${s.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-mist transition-colors hover:text-frost"
                >
                  {s}
                </button>}
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-2">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-mint">Destinations</p>
          <ul className="mt-5 space-y-3">
            {DESTINATION_LINKS.map((d, i) => (
              <li key={d}>
                <Link
                  to={`/destinations/${DESTINATION_SLUGS[i]}`}
                  data-testid={`footer-destination-link-${d.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-mist transition-colors hover:text-frost"
                >
                  {d}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="min-w-0 lg:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-mint">Reach us</p>
          <ul className="mt-5 space-y-3 text-sm text-mist">
            <li data-testid="footer-office-address">Sector 62, Noida,<br />Uttar Pradesh 201301</li>
            <li><a href={CONTACT.phoneHref} className="transition-colors hover:text-frost" data-testid="footer-phone-link">{CONTACT.phoneDisplay}</a></li>
            <li><a href={CONTACT.emailHref} className="break-words transition-colors hover:text-frost [overflow-wrap:anywhere]" data-testid="footer-email-link">{CONTACT.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-center justify-between gap-4 py-7 sm:flex-row">
          <p data-testid="footer-copyright" className="text-xs text-mist/70">© {year} Edubridge Study Abroad</p>
          <button
            onClick={() => scrollToSection("#book")}
            data-testid="footer-book-btn"
            className="group flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-mint transition-colors hover:text-mintlight"
          >
            Book free counseling
            <span className="h-1 w-1 rotate-45 bg-mint transition-transform duration-300 group-hover:scale-150" />
          </button>
        </div>
      </div>
    </footer>
  );
}
